<div class="notif-card" [ngClass]="{'unread': !notification?.read}">
  <span class="accent-bar" *ngIf="!notification?.read"></span>

  <div class="notif-avatar">
    <div class="logo-frame">
      <img [src]="profileUrl" (error)="onLogoError()" alt="company logo">
    </div>
    <span class="recurring-badge"><i class="fa fa-repeat"></i></span>
    <span class="unread-dot" *ngIf="!notification?.read"></span>
  </div>

  <div class="notif-body">
    <div class="notif-head">
      <p class="notif-company">{{ notification.notificationName }}</p>
      <span class="notif-date">{{ notification.created | momentPipe:'MMM DD' }} · {{ notification.created | momentPipe:'h:mm A' }}</span>
    </div>

    <span class="recurring-tag"><i class="fa fa-repeat"></i> Recurring shift</span>

    <p class="notif-message">{{ notification.body }}</p>

    <div class="notif-action" *ngIf="notification.showPopup">
      <button class="details-btn" (click)="seeDetails()">
        <span>See details</span>
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>
</div>
